<span class="relative grow">
  <input
    type="search"
    autocomplete="off"
    class="form-control border-r-0 pr-8"
    [placeholder]="inputPlaceholder"
    [formControlName]="inputName"
  />
  <app-icon class="absolute right-2 top-1/2 -translate-y-1/2" name="search"></app-icon>
</span>
<span class="z-[1002] -mx-px h-6 w-px bg-secondary-200"></span>
<ng-select
  #ngSelect
  bindLabel="label"
  bindValue="id"
  [formControlName]="selectName"
  [clearable]="false"
  [closeOnSelect]="false"
  [items]="searchParameters"
  [multiple]="true"
  placeholder="Szukaj według..."
  i18n-placeholder
  [searchable]="false"
  class="grow"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear" let-index="index">
    {{ item.label }}
    <ng-container *ngIf="ngSelect?.selectedItems?.length > 1">
      + {{ ngSelect?.selectedItems?.length - 1 }} <ng-container i18n>więcej</ng-container>
    </ng-container>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
    <div class="form-check">
      <input
        type="checkbox"
        [attr.aria-labelledby]="'item-' + index"
        class="form-check-input"
        [ngModel]="item$.selected"
        [ngModelOptions]="{ standalone: true }"
      />
      <label id="item-{{ index }}" class="form-check-label">{{ item.label }}</label>
    </div>
  </ng-template>
</ng-select>
